import './assets/main.css'

import { createApp } from 'vue'
import { createPinia } from 'pinia'
import * as Antd from 'ant-design-vue'
import App from './App.vue'
// import router from './router'
import 'ant-design-vue/dist/reset.css'
import { useAssistantStore } from './stores/assistant'

export type InitAIOptions = {
  element_id: string
  client_key: string
}
window.init_ai = ({ element_id = '#app', client_key }: InitAIOptions) => {
  const app = createApp(App)
  app.use(createPinia())

  const assistant_store = useAssistantStore()
  assistant_store.set_client_key(client_key)

  // app.use(router)
  app.use(Antd)
  app.mount(element_id)
}
